import * as React from "react";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";

interface OrgMeta {
    domain: string;
    id: string;
    name: string;
    minimumTeamMembers?: number;
    logoUrl?: string;
}

export const OrgContext = React.createContext<{ org: Partial<OrgMeta> }>({ org: {} });

export const OrgProvider = ({ children }) => {
    const { isDemo, isLoading, jwt } = useAuth();
    const [org, setOrg] = React.useState<Partial<OrgMeta>>({});

    const getOrg = async () => {
        let response: OrgMeta;
        if (isDemo) {
            // @ts-expect-error expected
            response = (await import("src/components/providers/mock-data/org")).default as OrgMeta;
        } else {
            response = await request<OrgMeta>(`/api/org`);
        }
        setOrg(response);
    };

    React.useEffect(() => {
        if (!isLoading && (isDemo || !!jwt)) {
            getOrg();
        }
    }, [isDemo, !!jwt, isLoading]);

    const value = React.useMemo(
        () => ({
            org,
        }),
        [org]
    );
    return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;
};

export const useOrg = () => {
    const context = React.useContext(OrgContext);
    if (context === undefined) {
        throw new Error(`useOrg must be used within a OrgProvider`);
    }
    return context;
};
